import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Avatar, IconButton, Menu, MenuItem, Badge, TextField, FormControl } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));
const phone = (
  <svg
    width="10"
    height="10"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.70633 1.34792C2.6145 1.38058 2.46848 1.46865 1.80987 2.16219C1.79105 2.18201 1.77103 2.20065 1.74992 2.21801C1.51123 2.41433 1.36172 2.69799 1.33445 3.00508C1.32977 3.82231 1.54479 4.62599 1.95723 5.33211C1.96546 5.3462 1.97317 5.36058 1.98034 5.37523C2.14457 5.71077 2.33393 6.03342 2.5468 6.3404C2.54945 6.34423 2.55206 6.34808 2.55463 6.35196C3.55404 7.8597 4.9159 9.0932 6.51571 9.93971C6.52364 9.94391 6.53148 9.94826 6.53923 9.95278C7.2199 10.3489 7.97893 10.5916 8.76329 10.6641C9.06339 10.6862 9.36053 10.595 9.59613 10.4092C9.60384 10.4016 9.61277 10.3928 9.62282 10.3829C9.71977 10.2875 9.92112 10.0893 10.136 9.86989L10.1362 9.86962C10.367 9.63414 10.4739 9.52177 10.5351 9.44945C10.5767 9.40042 10.5851 9.38564 10.612 9.33405C10.6152 9.32777 10.6186 9.32155 10.6221 9.31539C10.6796 9.2132 10.6802 9.0885 10.6236 8.98569C10.6183 8.97616 10.6133 8.96652 10.6085 8.95675C10.5888 8.91635 10.587 8.91496 10.5867 8.91458C10.5844 8.91115 10.5713 8.89223 10.5229 8.83901C10.4189 8.72476 10.2281 8.5339 9.8203 8.12665C9.42458 7.7328 9.23031 7.54077 9.1141 7.43537C9.03537 7.36397 9.02516 7.36127 9.01881 7.35959C9.01776 7.35931 9.01681 7.35905 9.01567 7.35852C9.01169 7.35666 9.00774 7.35475 9.0038 7.35281C8.89366 7.29852 8.76482 7.29967 8.65622 7.35452C8.4935 7.48883 8.3381 7.6318 8.19078 7.78276C8.18757 7.78605 8.18433 7.7893 8.18105 7.79252L7.89136 8.07736C7.5771 8.3833 7.10055 8.45049 6.71377 8.24351C6.70563 8.23916 6.69759 8.23463 6.68964 8.22995C5.46212 7.50603 4.43959 6.48153 3.71871 5.25317C3.71228 5.24221 3.70617 5.23107 3.70037 5.21976C3.51826 4.86432 3.58488 4.43249 3.86538 4.14823L3.8681 4.14547L4.16633 3.84676C4.16642 3.84666 4.16652 3.84657 4.16661 3.84648C4.61763 3.39339 4.63703 3.33589 4.6519 3.29184C4.65271 3.28944 4.65351 3.28707 4.65437 3.28468L4.65608 3.27991C4.69168 3.18278 4.68374 3.07507 4.63426 2.98422C4.63111 2.97844 4.62805 2.97262 4.62508 2.96676C4.6198 2.95633 4.61918 2.95551 4.61733 2.95303C4.61706 2.95269 4.61678 2.9523 4.61645 2.95186C4.60875 2.94135 4.58803 2.91508 4.53433 2.85696C4.42395 2.7375 4.22834 2.54099 3.84601 2.16094M2.70633 1.34792C2.78889 1.32882 2.87459 1.32763 2.95762 1.34443C2.97149 1.34866 2.97954 1.35139 2.98486 1.35335C2.99059 1.35547 2.99197 1.35625 2.99226 1.35641C2.99317 1.35687 3.01316 1.36707 3.0693 1.41372C3.19818 1.52081 3.40475 1.72252 3.84601 2.16094M2.34989 0.0633041C2.65262 -0.0162193 2.97022 -0.0209 3.27521 0.0497201C3.28731 0.0525215 3.29933 0.0556597 3.31125 0.059131C3.39087 0.0823134 3.49367 0.114656 3.60852 0.174382C3.72171 0.23324 3.82213 0.305666 3.92276 0.389292C4.10901 0.544056 4.36734 0.799099 4.78711 1.21617C5.16083 1.58766 5.38073 1.80791 5.51497 1.95319C5.65932 2.10941 5.73875 2.21529 5.81116 2.35615C6.03924 2.7808 6.0753 3.28257 5.91005 3.73556C5.777 4.10569 5.552 4.34496 5.11263 4.78633L5.04184 4.85725C5.58608 5.69319 6.30207 6.40442 7.14248 6.94357L7.24009 6.84759C7.43432 6.64895 7.63987 6.46171 7.8556 6.28683C7.87769 6.26892 7.9009 6.25245 7.92509 6.23751C8.42856 5.92645 9.05665 5.89531 9.58833 6.15482C9.73655 6.22483 9.84365 6.29686 10.0112 6.44883C10.1565 6.58059 10.3788 6.8011 10.7628 7.18332L10.7637 7.18413L10.79 7.21042C11.1664 7.58631 11.3817 7.80138 11.5103 7.94261C11.6667 8.11451 11.7318 8.21866 11.8011 8.35877C12.0698 8.85898 12.0661 9.46153 11.7908 9.95849C11.6502 10.2257 11.524 10.3588 11.0898 10.8018L10.6133 10.336L11.0901 10.8015C11.09 10.8016 11.0899 10.8017 11.0898 10.8018C10.8605 11.0361 10.6337 11.2592 10.5475 11.3439C10.5301 11.361 10.5184 11.3725 10.5137 11.3773C10.4988 11.3921 10.4832 11.4063 10.4669 11.4197C9.96045 11.8378 9.31118 12.0431 8.65605 11.9924L8.6467 11.9917C7.67103 11.9024 6.72667 11.6019 5.87924 11.1111C5.88316 11.1132 5.88707 11.1152 5.89099 11.1173L6.20335 10.5285L5.86746 11.1042C5.87139 11.1065 5.87531 11.1088 5.87924 11.1111C4.08949 10.1615 2.56553 8.78053 1.44581 7.09337C1.44714 7.09529 1.44847 7.09721 1.4498 7.09914L1.9983 6.71977L1.44197 7.08758C1.44325 7.08951 1.44453 7.09144 1.44581 7.09337C1.20088 6.73955 0.982421 6.36815 0.792202 5.98223C0.796328 5.98936 0.80047 5.99649 0.804627 6.00361L1.38093 5.66786L0.781522 5.96049C0.785072 5.96774 0.788632 5.97499 0.792202 5.98223C0.262718 5.06694 -0.0108552 4.02619 0.000329717 2.96886C0.000474206 2.9552 0.00103944 2.94154 0.00202448 2.92792C0.0499807 2.26452 0.36224 1.64868 0.867821 1.21762C0.859161 1.22672 0.850449 1.23589 0.841684 1.24512L1.32578 1.70366L0.901634 1.1893C0.890269 1.19865 0.878998 1.20809 0.867821 1.21762C1.49206 0.561138 1.84352 0.224581 2.31575 0.0732483C2.32704 0.0696313 2.33842 0.0663154 2.34989 0.0633041Z"
      fill="#FF725E"
    />
  </svg>
);

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 675,
  borderRadius: 2,
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  py: 2,
  px: 4,
};
interface LongMenuProps {
  openFn: () => void;
}
const LongMenu: React.FC<LongMenuProps> = ({ openFn }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 216,
            width: "20ch",
          },
        }}
      >
        <MenuItem onClick={openFn}>View Comments</MenuItem>
      </Menu>
    </div>
  );
};
export default function ActionModal({ rowData }: any) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <div>
      <LongMenu openFn={handleOpen} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="flex justify-between mb-4">
            <p className="font-bold text-base"> {rowData.shopName}</p>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex justify-between">
            <div>
              <div className="border border-slate-300	py-3 px-6 rounded-lg  mt-3">
                <p className="text-sm font-semibold py-2 border-b">
                  Request Details
                </p>
                <div className="ml-2 flex">
                  <div className="mr-4 mt-3">
                    <StyledBadge
                      overlap="circular"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      variant="dot"
                    >
                      <Avatar>YS</Avatar>
                    </StyledBadge>
                  </div>
                  <div className="mt-3">
                    <div>
                      <p className="text-sm font-semibold text-left text-slate-700">
                        {rowData.name}
                      </p>
                      <p className="font-medium	text-left text-slate-700 flex items-center mt-1 text-xs">
                        <img
                          src={"/assets/icons/mobileIcon.svg"}
                          alt=""
                          className="h-4 mr-1"
                        />
                        {rowData?.hmMobile}
                      </p>
                    </div>
                  </div>

                  <div className="flex mt-3">
                    <div className="flex ml-2">
                      <div className="mr-6">
                        <p className="text-sm font-semibold text-left">
                          Address
                        </p>

                        <p className="text-base text-left text-slate-600">
                          {rowData?.shopAddr}
                        </p>
                      </div>
                      <div className="mr-6">
                        <p className="text-sm font-semibold text-left">
                          Fleet Demand
                        </p>

                        <p className="text-base text-left text-slate-600">
                          {rowData?.noOfPilot}
                        </p>
                      </div>
                      <div className="mr-6">
                        <p className="text-sm font-semibold text-left">
                          Time Shift
                        </p>

                        <p className="text-base text-left text-slate-600">
                          {rowData.startTime}-{rowData.endTime}
                        </p>
                      </div>
                      <div className="mr-6">
                        <p className="text-sm font-semibold text-left">
                          Start Date
                        </p>

                        <p className="text-base text-left text-slate-600">
                          {rowData.startDate}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-2">
            <FormControl fullWidth>
            <label htmlFor="email" className="text-left mb-3">
                  Additional Comments:
                </label>
            <TextField id="outlined-multiline-static" multiline disabled rows={4}
 defaultValue={rowData.requirement}></TextField>
            </FormControl>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
